import { getRangeDateQuery } from "./format";

export const checkTimeSurveyEnabled = (endDate: any) => {
  if(!endDate) return false
	const endDateTime = new Date(endDate).getTime();
	const { start, end } = getRangeDateQuery(new Date(), new Date());
	const currentDateTime = new Date(end).getTime();
	return currentDateTime > endDateTime;
};
